import { render, staticRenderFns } from "./EditWorkingFile.vue?vue&type=template&id=37f215e8&scoped=true&"
import script from "./EditWorkingFile.vue?vue&type=script&lang=js&"
export * from "./EditWorkingFile.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkingFile.vue?vue&type=style&index=0&id=37f215e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f215e8",
  null
  
)

export default component.exports